import { ColourPalette, Playlist } from '@repo/types'
import { observer } from 'mobx-react-lite'
import React from 'react'

import { ImportSpotifyUrlContainer } from './import-spotify-url-container'
import { useCreateSystemPlaylist } from '../../playlist-queries/system-playlists/useCreateSystemPlaylist'
import { useCreateUserPlaylist } from '../../playlist-queries/user-playlists/useCreateUserPlaylist'

export const ImportSpotifyPlaylistUrlRoute = observer(
  function ImportSpotifyPlaylistUrlRoute(): React.ReactElement {
    const { mutateAsync: createUserPlaylist } = useCreateUserPlaylist()

    const handleSubmit = async (playlist: Playlist) => {
      return createUserPlaylist({
        ...playlist,
        colour: ColourPalette.PURPLE,
        id: ''
      })
    }

    return <ImportSpotifyUrlContainer onSubmit={handleSubmit} />
  }
)

export const ImportSpotifyPlaylistUrlRouteAdmin = observer(
  function ImportSpotifyPlaylistUrlRouteAdmin(): React.ReactElement {
    const { mutateAsync: createSystemPlaylist } = useCreateSystemPlaylist()

    const handleSubmit = async (playlist: Playlist) => {
      return createSystemPlaylist({
        ...playlist,
        colour: ColourPalette.PURPLE,
        id: ''
      })
    }

    return <ImportSpotifyUrlContainer baseUrl='/admin/' onSubmit={handleSubmit} />
  }
)
